import type { Viewport } from "@xyflow/react";

export const CANVAS_LIVE_VIEWPORT_EVENT = "denker:canvas-live-viewport";

const LIVE_VIEWPORT_MAX_AGE_MS = 250;

let latestViewport: {
  viewport: Viewport;
  scopeId: string | null;
  publishedAt: number;
} | null = null;

export function publishLiveCanvasViewport(
  viewport: Viewport,
  scopeId: string | null,
): void {
  latestViewport = { viewport, scopeId, publishedAt: Date.now() };
  window.dispatchEvent(
    new CustomEvent(CANVAS_LIVE_VIEWPORT_EVENT, { detail: viewport }),
  );
}

export function getLiveCanvasViewport(scopeId: string | null): Viewport | null {
  if (!latestViewport || latestViewport.scopeId !== scopeId) return null;
  if (Date.now() - latestViewport.publishedAt > LIVE_VIEWPORT_MAX_AGE_MS) {
    latestViewport = null;
    return null;
  }
  return latestViewport.viewport;
}

export function clearLiveCanvasViewport(): void {
  latestViewport = null;
}
